import { DISTANCE_UNIT_KILOMETER, DISTANCE_UNIT_MILE } from 'Lib/utils/distance';

import type { BiometricsLivenessState } from 'Store/userBiometrics/types';

import type { AgeVerificationStatus } from 'Components/AgeVerification/constants';

export type BiometricConsents = {
  code: string;
}[];

export type ChatSuggestionConsents = {
  code: string;
  categoryCode: string;
  title: string;
  metadata: any;
  consentStatus: string;
}[];

export type MessageConsents = {
  code: string;
}[];

export type SettingsOrientation = {
  id: string;
  name: string;
  description: string;
};

export type SubscriptionFeature = any[];

export enum ThemeId {
  Dark = 'dark',
  Light = 'light',
}

export type DistanceUnit = typeof DISTANCE_UNIT_MILE | typeof DISTANCE_UNIT_KILOMETER;

export type AppSettingsState = {
  ageVerificationIsSessionOnboardingSkippable: boolean;
  ageVerificationReason: number;
  ageVerificationShowSessionOnboardingModal: boolean;
  ageVerificationStatus: AgeVerificationStatus;
  appStartInfo: string;
  biometricConsents: BiometricConsents;
  biometricLivenessState: BiometricsLivenessState;
  distanceUnit: DistanceUnit;
  canEditEmail: boolean;
  chatSuggestionConsents: ChatSuggestionConsents;
  companyMaxLength: number;
  consent: string[] | null;
  emailVerificationDismissible: boolean;
  emailVerificationRequired: boolean;
  globalPassportDescription: string;
  globalPassportTitle: string;
  chatSuggestionConsentShown: boolean;
  isBiometricConsentNeeded: boolean;
  isConsumablesEnabled: boolean;
  isGoldEnabled: boolean;
  isHubbleDebuggerEnabled: boolean;
  isMessageConsentNeeded: boolean;
  isPlatinumEnabled: boolean;
  isTermsAcceptanceNeeded: boolean;
  isTinderPlusEnabled: boolean;
  jobTitleMaxLength: number;
  layout: string;
  merchandisingFeatures: string[] | null;
  messageConsents: MessageConsents;
  orientationEnabled: boolean | null;
  orientations: SettingsOrientation[];
  paywallFeatures: string[];
  platinumPaywallFeatures: string[];
  recsToolbarIsOpened: boolean;
  schoolMaxLength: number;
  showTerms: boolean;
  superBoostMembersText: string;
  superlikeAlcMode: number;
  termsVersion: string | null;
  themeDevicePreference: ThemeId | undefined;
  themePreference: ThemeId | null;
  typingPulseInterval: number;
  typingTimeout: number;
};
